export const dataUnavailableForOlderRateMessage =
  'Data not available due to the age of this price request'
